var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "Merriweather-Bold, Merriweather",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-49.000000, -145.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("text", {
    id: "icon-header-option"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 49,
    y: 156
  }, "H"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderOption);
export default __webpack_public_path__ + "static/media/icon-header-option.b40006ea6d1beba6e06352ce0e777ae0.svg";
export { ForwardRef as ReactComponent };